import React from 'react'
import styled from 'styled-components'

const SquareContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  @media (max-width: 620px) {
    max-width: 4.5rem;
  }
`

export default SquareContainer



// WEBPACK FOOTER //
// ../components/styled/SquareContainer.js